import * as Yup from 'yup';

export default Yup
  .string()
  .email('Insira um endereço de e-mail válido')
  .required('Este campo é obrigatório');
